import Description from '@/features/ui/typography/components/Description'
import Heading from '@/features/ui/typography/components/Heading'
import Animated from 'react-native-reanimated'

export default {
    Heading: Animated.createAnimatedComponent(Heading),
    Description: Animated.createAnimatedComponent(Description),
}
